<template>
	<div class="clients">
		<div class="jumbotron">
			<div class="container">
				<h1 class="display-3">Klijenti</h1>
				<p>Baza firmi sa kojima se sarađuje.</p>
				<p class="lead">
    				<button type="button" class="btn btn-primary btn-lg" data-toggle="modal" data-target="#client-modal">Dodaj klijenta</button>
  				</p>
			</div>
		</div>

		<div class="container">
			<table class="table table-hover table-responsive">
				<thead class="thead-light">
					<tr>
						<th>Naziv</th>
						<th>Adresa</th>
						<th>PIB</th>
						<th>Matični broj</th>
						<th class="shrink-column"></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="client in clientState.clients">
						<td>{{client.name}}</td>
						<td>{{client.address}}</td>
						<td>{{client.taxNumber}}</td>
						<td>{{client.registrationNumber}}</td>
						<td class="shrink-column">
							<button type="button" class="btn btn-light btn-sm" data-toggle="modal" data-target="#client-modal" @click="edit(client.id)"><i class="material-icons md-18">edit</i></button>
							<button type="button" class="btn btn-light btn-sm" @click="remove(client.id)"><i class="material-icons md-18">delete</i></button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div id="client-modal" class="modal fade" tabindex="-1" role="dialog" ref="clientModal">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Klijent</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<form>
							<div class="form-group">
								<label>Naziv</label>
								<input type="text" v-model="currentClient.name" class="form-control">
							</div>
							<div class="form-group">
								<label>Adresa</label>
								<input type="text" v-model="currentClient.address" class="form-control">
							</div>
							<div class="form-row">
								<div class="form-group col-md-4">
									<label>PIB</label>
									<input type="text" v-model="currentClient.taxNumber" class="form-control">
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-md-4">
									<label>Matični broj</label>
									<input type="text" v-model="currentClient.registrationNumber" class="form-control">
								</div>
							</div>
						</form>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Odustani</button>
						<button type="button" class="btn btn-primary" @click="saveOrUpdate">Sačuvaj</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { clientStore } from '../stores/clients';

export default {
	name: 'clients',

	data() {
		return {
			clientState: clientStore.state,
			currentClient: clientStore.createEmpty()
		};
	},

	mounted() {
		window.jQuery(this.$refs.clientModal).on('hidden.bs.modal', (e) => {
			this.currentClient = clientStore.createEmpty();
		});
	},

	methods: {
		edit(id) {
			this.currentClient = Object.assign({}, clientStore.get(id));
		},

		saveOrUpdate() {
			if (this.currentClient.id !== null) {
				this.update(this.currentClient)
					.then(() => {
						window.jQuery(this.$refs.clientModal).modal('hide');
					});
			}
			else {
				this.save(this.currentClient)
					.then(() => {
						window.jQuery(this.$refs.clientModal).modal('hide');
					});
			}
		},

		save(client) {
			return clientStore.save(client)
				.then((docRef) => {
					this.$toasted.success('Klijent sačuvan.', {
						icon: 'done'
					});
				})
				.catch((error) => {
					this.$toasted.error('Nije uspelo čuvanje klijenta. ' + error.toString(), {
						icon: 'error_outline'
					});
				});
		},

		update(client) {
			return clientStore.update(client.id, {
				name: client.name,
				address: client.address,
				taxNumber: client.taxNumber,
				registrationNumber: client.registrationNumber
			})
			.then(() => {
				this.$toasted.success('Izmene klijenta sačuvane.', {
					icon: 'done'
				});
			})
			.catch((error) => {
				this.$toasted.error('Nije uspelo čuvanje izmena klijenta. ' + error.toString(), {
					icon: 'error_outline'
				});
			});
		},

		remove(id) {
			clientStore.delete(id)
				.then(() => {
					this.$toasted.success('Klijent obrisan.', {
						icon: 'done'
					});
				})
				.catch((error) => {
					this.$toasted.error('Nije uspelo brisanje klijenta. ' + error.toString(), {
						icon: 'error_outline'
					});
				});
		}
	}
};
</script>

<style scoped>
.table .shrink-column {
	white-space: nowrap;
	width: 0.1%;
}

.table td {
	vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// Clients.vue?288d4a45